import { Env } from "@humanwhocodes/env";

const env = new Env();
const DEFAULT_SUPABASE_URL = "http://localhost:54321";
  const DEFAULT_SUPABASE_ANON_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";
  const DEFAULT_SUPABASE_SERVICE_ROLE_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImV4cCI6MTk4MzgxMjk5Nn0.EGIM96RAZx35lJzdJsyH-qQwv8Hdp7fsn3W0YpN81IU";

function mapAppend(prefixes, suffix) {
  return prefixes.map((prefix) => prefix + suffix);
}

function envDB(prefixes) {
  const mapSuffix = (suffix) => mapAppend(prefixes, suffix);

  const host = env.first(mapSuffix("HOST"), "localhost");
  const port = parseInt(env.first(mapSuffix("PORT"), "54322"));
  const password = env.first(mapSuffix("PASSWORD"), "postgres");
  const database = env.first(mapSuffix("DATABASE"), "postgres");
  const user = env.first(mapSuffix("USER"), "postgres");
  const max = parseInt(env.first(mapSuffix("MAX_CONNECTIONS"), '5'));

  return { host, port, password, database, user, max };
}

function envSupabase(prefixes) {
  const mapSuffix = (suffix) => mapAppend(prefixes, suffix);

  const supabaseURL = env.first(mapSuffix("SUPABASE_URL"), DEFAULT_SUPABASE_URL);
  const supabaseAnonKey = env.first(mapSuffix("SUPABASE_ANON_KEY"), DEFAULT_SUPABASE_ANON_KEY);

  // Service role key should never be exposed; don't accept any prefixes
  const supabaseServiceRoleKey = env.first(["SUPABASE_SERVICE_ROLE_KEY"], DEFAULT_SUPABASE_SERVICE_ROLE_KEY);
  return { supabaseURL, supabaseServiceRoleKey, supabaseAnonKey};
}

const db = envDB(["SUPABASE_DB_", "DB_", "POSTGRES_", "PG"]);
const api = envSupabase(["", "VITE_APP_", "PUBLIC_"])

export { db, api };
